"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.display_productSection = void 0;
var utils_1 = require("../../utils");
var qs_1 = require("qs");
// [Product Section]
exports.display_productSection = function (axios) {
    return {
        getProductSections: function (request) {
            var query = qs_1.stringify(request.params, { arrayFormat: 'comma' });
            return axios.get("/product-sections?" + query);
        },
        getProductSectionsDuplicate: function (request) {
            return axios.get('/product-sections/duplicate', request);
        },
        postProductSections: function (request) {
            return axios.post('/product-sections', request.data);
        },
        deleteProductSections: function (request) {
            return axios.delete('/product-sections', request);
        },
        getProductSectionsProductSectionNo: function (request) {
            var url = utils_1.paramPathchange('/product-sections/{productSectionNo}', request);
            return axios.get(url, request);
        },
        putProductSectionsProductSectionNo: function (request) {
            var url = utils_1.paramPathchange('/product-sections/{productSectionNo}', request);
            return axios.put(url, request.data);
        },
        getProductSectionsExcel: function (request) {
            return axios.get('/product-sections/excel', request);
        },
        putProductSectionsDisplayable: function (request) {
            var url = utils_1.paramPathchange('/product-sections/{productSectionNo}/displayable', request);
            return axios.put(url, request.data);
        }
    };
};
